import React from "react";
import { NavLink } from "react-router-dom";
import navLinks from "../../data/dummyData";
import "./Navbar.css";
import CV from "../../reuseable/CV/CV";

function Navbar() {
  return (
    <header className="header">
      <nav className="nav container">
        <div className="nav-list">
          {navLinks.map((link, index) => (
            <NavLink key={index} to={link.to}>
              {link.icon}
            </NavLink>
          ))}
        </div>
        <CV />
      </nav>
    </header>
  );
}

export default Navbar;
